import React from 'react';
import { IconComponent, CircleIconComponent } from '@shapeable/types'

export const HorizonOne: CircleIconComponent = ({ className, height, width, viewBox, fill }) => (
  <svg className={className} width={width || "18"} height={height || "17"} viewBox={viewBox || "0 0 18 17"} fill='none'>
    <path d="M9 0C4.30375 0 0.5 3.80375 0.5 8.5C0.5 13.1962 4.30375 17 9 17C13.6962 17 17.5 13.1962 17.5 8.5C17.5 3.80375 13.6962 0 9 0ZM7.66125 12.6331L6.99188 11.9425L6.3225 11.2519L3.65563 8.5L4.99438 7.11875L7.66125 9.87062L13.0056 4.35625L14.3444 5.7375L7.66125 12.6331Z" fill={fill}/>
  </svg>  
);